import { getClassNamesFromArray } from '@common/utils';
export const LabelWrapper = ({
  children,
  className
}) => <div className={getClassNamesFromArray(['padding-top padding-left', className])}>
    {children}
  </div>;